import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import NavigationConstants from '../LobbyOverlay/NavigationConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens';
import Utils from '../../utils';
import AppInterface from '../../api/AppInterface';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import { TooltipTypes } from '../../utils/tooltipConstants';
import { FE_EVENTS } from '../../utils/featureFlags/constants';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import _rewardCenterMiddleware from '../../screens/RewardCenter/utils/middleware';
import NotificationContext from '../../context/NotificationContext';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var NavigationBar = /*#__PURE__*/function (_Component) {
  function NavigationBar(props) {
    var _this2;

    _classCallCheck(this, NavigationBar);

    _this2 = _callSuper2(this, NavigationBar, [props]);

    _this2._changeTooltipType = function (type) {
      if (type !== TooltipTypes.COINS) _this2.props.shouldShowTooltip(false);

      _this2.setState({
        tooltipType: type
      }, function () {
        if (type) {
          clearTimeout(_this2.tooltipTimeout);
          _this2.tooltipTimeout = setTimeout(function () {
            _this2.setState({
              tooltipType: null
            });

            _this2.props.shouldShowTooltip(false);
          }, 2500);
        } else {
          clearTimeout(_this2.tooltipTimeout);
        }
      });
    };

    _this2.screensWithHomeButton = [Screens.Game, Screens.Missions, Screens.Events, Screens.RewardCenter];

    _this2.showHomeButton = function () {
      var currentScreen = _this2.props.navigation.state.routes[_this2.props.navigation.state.index].key;
      return _this2.screensWithHomeButton.includes(currentScreen);
    };

    _this2.sendStoreOpenedEvent = function (type) {
      var trigger = Logger.getActionTrigger();
      var eventPayload = {
        balance_before: _this2.props.coin.value.toString(),
        type: type,
        trigger: trigger || ''
      };
      Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
    };

    _this2._showModal = function (modalType, modalArgs) {
      audio.onClick();
      var _this2$props = _this2.props,
          sidebarState = _this2$props.sidebarState,
          setSidebarState = _this2$props.setSidebarState;
      setSidebarState(!sidebarState);

      if (modalType === 'ShopScreen') {
        Logger.setActionTrigger('topBar');
        var type = modalArgs ? 'vip' : 'regular';

        _this2.sendStoreOpenedEvent(type);
      }

      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType));

      if (modalArgs) {
        QueryParamsProxy.setQueryParams(modalArgs);
      }

      _this2.props.setModal(modalType);
    };

    _this2._addNotif = function (notif) {
      _this2.props.addNotif(notif);
    };

    _this2._getInitAppResponse = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AppInterface.initApp();

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this2._checkForEvents = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _useFeatureFlags, hasFeature;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
              _context2.next = 3;
              return AppInterface.updateAppEvents();

            case 3:
              if (hasFeature(FE_EVENTS)) {
                _this2.props.getEvents({
                  playerId: _this2.props.playerId,
                  requestAssetsData: true
                }, {
                  subscribe: false,
                  forceRefetch: true
                });
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this2.navigateBack = function () {
      audio.onClick();
      QueryParamsProxy.navigate(_this2.props.navigation, Screens.Home);
      QueryParamsProxy.updateURL();

      _this2._checkForEvents();
    };

    _this2.getCurrentScreen = function () {
      var routeKey = _this2.props.navigation.state.routes[_this2.props.navigation.state.index].key;
      return {
        isMissions: routeKey === Screens.Missions,
        isHome: routeKey === Screens.Home,
        isGame: routeKey === Screens.Game,
        isEvents: routeKey === Screens.Events,
        isRewardCenter: routeKey === Screens.RewardCenter
      };
    };

    _this2.state = {
      visible: true,
      messageCount: 0,
      tooltipType: null
    };
    _this2.tooltipTimeout;
    return _this2;
  }

  _inherits(NavigationBar, _Component);

  return _createClass(NavigationBar, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var newNavState = nextProps.navState;

      if (newNavState !== this.props.navState) {
        switch (newNavState) {
          case NavigationConstants.HIDE_TOP:
          case NavigationConstants.HIDE_BOTH:
            {
              this.setState({
                visible: false
              });
              break;
            }

          default:
            {
              if (this.props.triggerNavStateAnimationFn) {
                var currentScreen = this.props.navigation.state.routes[this.props.navigation.state.index].key;
                var isGameScreen = currentScreen === Screens.Game;
                this.props.triggerNavStateAnimationFn(newNavState, this.showHomeButton(), isGameScreen);
              }

              this.setState({
                visible: true
              });
            }
        }
      }
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (this.state.visible !== nextState.visible) {
        if (this.props.sharedWillUpdate) {
          this.props.sharedWillUpdate(nextProps, nextState);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          navState = _this$props.navState,
          coin = _this$props.coin,
          level = _this$props.level,
          loyalty = _this$props.loyalty,
          sale = _this$props.sale,
          limitedTimeOffer = _this$props.limitedTimeOffer,
          sidebarState = _this$props.sidebarState,
          setSidebarState = _this$props.setSidebarState,
          ftueStep = _this$props.ftueStep,
          tooltipDetails = _this$props.tooltipDetails,
          shouldShowTooltip = _this$props.shouldShowTooltip,
          showLinkLoyaltyCardSetting = _this$props.showLinkLoyaltyCardSetting,
          activeTutorial = _this$props.activeTutorial,
          showMissionsProgressBar = _this$props.showMissionsProgressBar,
          missionsAssets = _this$props.missionsAssets,
          assetsLoaded = _this$props.assetsLoaded;

      var _this$getCurrentScree = this.getCurrentScreen(),
          isMissions = _this$getCurrentScree.isMissions,
          isHome = _this$getCurrentScree.isHome,
          isGame = _this$getCurrentScree.isGame,
          isEvents = _this$getCurrentScree.isEvents,
          isRewardCenter = _this$getCurrentScree.isRewardCenter;

      var showCoinBalance = navState !== NavigationConstants.HIDE_BOTTOM || isMissions || isEvents || isRewardCenter;
      var IapButtonState = sale ? NavigationBar.EIapButtonStates.Sale : NavigationBar.EIapButtonStates.NoSale;

      if (IapButtonState === NavigationBar.EIapButtonStates.Sale) {
        if (!Utils.isEmpty(limitedTimeOffer)) {
          IapButtonState = NavigationBar.EIapButtonStates.SaleDeal;
        }
      } else if (IapButtonState === NavigationBar.EIapButtonStates.NoSale) {
        if (!Utils.isEmpty(limitedTimeOffer)) {
          IapButtonState = NavigationBar.EIapButtonStates.NoSaleDeal;
        }
      }

      return this.props.render({
        navState: navState,
        IapButtonState: IapButtonState,
        limitedTimeOffer: this.props.limitedTimeOffer,
        coins: coin.value,
        level: format(level),
        loyalty: loyalty.value,
        showModal: this._showModal,
        addNotif: this._addNotif,
        navigateBack: this.navigateBack,
        tooltipType: this.state.tooltipType,
        changeTooltipType: this._changeTooltipType,
        showCoinBalance: showCoinBalance,
        isMissions: isMissions,
        isHome: isHome,
        isGame: isGame,
        sidebarState: sidebarState,
        setSidebarState: setSidebarState,
        ftueStep: ftueStep,
        tooltipDetails: tooltipDetails,
        shouldShowTooltip: shouldShowTooltip,
        showLinkLoyaltyCardSetting: showLinkLoyaltyCardSetting,
        showHomeButton: this.showHomeButton,
        activeTutorial: activeTutorial,
        showMissionsProgressBar: showMissionsProgressBar && missionsAssets && assetsLoaded,
        rewardCenterMiddleware: function rewardCenterMiddleware() {
          return _rewardCenterMiddleware(_objectSpread(_objectSpread({}, _this3.props), {}, {
            notificationContext: _this3.context
          }));
        }
      });
    }
  }]);
}(Component);

NavigationBar.contextType = NotificationContext;
NavigationBar.EIapButtonStates = {
  NoSale: 0,
  Sale: 1,
  NoSaleDeal: 2,
  SaleDeal: 3
};
export { NavigationBar as default };